/* Battery Service Limburg — accu-landing interacties (gedeeld door alle bsl-accu-* secties) */
(function(){
  'use strict';

  function initBSLAL(){
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* REVEAL bij in-view */
    var els = document.querySelectorAll('.bslal--anim:not([data-bslal-obs])');
    if(els.length){
      var rObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('bslal--vis'); });
      },{threshold:0.08, rootMargin:'0px 0px -32px 0px'});
      els.forEach(function(el){ el.setAttribute('data-bslal-obs','1'); rObs.observe(el); });
    }

    /* COUNT-UP + GAUGE bij in-view */
    function animVal(el,to,suffix,dur){
      if(reduce){ el.textContent = to + (suffix||''); return; }
      var start=null;
      function tick(ts){ if(!start) start=ts; var p=Math.min((ts-start)/dur,1);
        el.textContent = Math.round(to*p) + (suffix||''); if(p<1) requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    var animObs = new IntersectionObserver(function(es){ es.forEach(function(e){
      if(!e.isIntersecting || e.target.dataset.done) return; e.target.dataset.done='1';
      if(e.target.hasAttribute('data-count')) animVal(e.target, parseInt(e.target.dataset.count,10), e.target.dataset.suffix||'', 1100);
      if(e.target.hasAttribute('data-gauge')){ var f=e.target.querySelector('[data-gauge-fill]'); if(f){ f.style.transition = reduce?'none':'width 1.4s cubic-bezier(.16,1,.3,1)'; f.style.width = e.target.dataset.gauge + '%'; } }
    }); },{threshold:0.4});
    document.querySelectorAll('[data-count]:not([data-bslal-obs]),[data-gauge]:not([data-bslal-obs])').forEach(function(el){ el.setAttribute('data-bslal-obs','1'); animObs.observe(el); });

    /* FAQ accordion — sluit andere items binnen dezelfde sectie */
    document.querySelectorAll('.bslal__faq-item:not([data-bslal-faq])').forEach(function(item){
      item.setAttribute('data-bslal-faq','1');
      item.addEventListener('toggle',function(){
        if(item.open){
          var scope = item.closest('.bslal') || document;
          scope.querySelectorAll('.bslal__faq-item').forEach(function(o){ if(o!==item && o.open) o.removeAttribute('open'); });
        }
      });
    });

    /* Sticky CTA-balk */
    var sticky = document.getElementById('bslal-sticky');
    if(sticky && !sticky.dataset.bslalSticky){
      sticky.dataset.bslalSticky='1';
      sticky.style.display='none';
      var contactInView = false;
      var contactEl = document.querySelector('.bslal__contact');
      function updateSticky(){ sticky.style.display = (window.scrollY > 400 && !contactInView) ? '' : 'none'; }
      if(contactEl && 'IntersectionObserver' in window){
        new IntersectionObserver(function(es){ contactInView = es[0].isIntersecting; updateSticky(); }, {threshold:0}).observe(contactEl);
      }
      window.addEventListener('scroll', updateSticky, {passive:true});
    }

    /* VOOR/NA sleep-vergelijking */
    document.querySelectorAll('[data-ba]:not([data-bslal-ba])').forEach(function(ba){
      ba.setAttribute('data-bslal-ba','1');
      var range = ba.querySelector('[data-ba-range]');
      if(!range) return;
      function setPos(v){ ba.style.setProperty('--pos', v + '%'); }
      setPos(range.value);
      range.addEventListener('input',function(){ setPos(range.value); });
      function moveFromEvent(clientX){
        var r = ba.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, (clientX - r.left) / r.width * 100));
        range.value = pct; setPos(pct);
      }
      var dragging=false;
      ba.addEventListener('pointerdown',function(e){ dragging=true; moveFromEvent(e.clientX); });
      window.addEventListener('pointermove',function(e){ if(dragging) moveFromEvent(e.clientX); },{passive:true});
      window.addEventListener('pointerup',function(){ dragging=false; });
    });
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initBSLAL); }
  else { initBSLAL(); }
  document.addEventListener('shopify:section:load', initBSLAL);
})();
